import { string, struct } from 'io-ts/Decoder';

import { EwpId, FloorId, FrameId, Id, RoofId, WholeHouseId } from './Id';

export const RoofRefItem = struct({
	id: RoofId,
	name: string,
});

export const FloorRefItem = struct({
	id: FloorId,
	name: string,
});

export const FrameRefItem = struct({
	id: FrameId,
	name: string,
});

export const EwpRefItem = struct({
	id: EwpId,
	name: string,
});

export const WholeHouseRefItem = struct({
	id: WholeHouseId,
	name: string,
});

export const RefItem = struct({
	id: Id,
	name: string,
});
